import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {Operator, OPERATOR_TO_TEXT, RELATIVE_RANGE_SHORTCUT_OPERATORS} from 'search/SearchConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Section from 'ui-library/menus/Section';
import SectionHeader from 'ui-library/menus/SectionHeader';

interface OperatorDropdownProps {
  buttonSize: ButtonSize;
  onChangeOperator: (value: Operator) => void;
  operators: Array<Operator>;
  selectedOperator: Operator;
}

function OperatorDropdown(props: OperatorDropdownProps): JSX.Element {
  return (
    <Dropdown
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL} value={props.selectedOperator}>
          <Section>
            {props.operators
              // The RELATIVE_RANGE operator should go in a separate Section with client side only
              // operators at the bottom of the menu.
              .filter((operator: Operator) => operator !== Operator.RELATIVE_RANGE)
              .map((operator: Operator) => (
                <Option
                  key={operator}
                  value={operator}
                  onSelect={props.onChangeOperator}
                  dataTestAttrs={{component: 'OperatorDropdown', element: 'option', key: operator}}
                >
                  {OPERATOR_TO_TEXT[operator]}
                </Option>
              ))}
          </Section>
          {props.operators.includes(Operator.RELATIVE_RANGE) && (
            <Section>
              <SectionHeader className={`faded ${css(styles.operatorSectionHeader)}`}>
                Relative date ranges
              </SectionHeader>
              {RELATIVE_RANGE_SHORTCUT_OPERATORS.concat([Operator.RELATIVE_RANGE]).map(
                (operator: Operator) => (
                  <Option
                    key={operator}
                    value={operator}
                    onSelect={props.onChangeOperator}
                    dataTestAttrs={{component: 'OperatorDropdown', element: 'option', key: operator}}
                  >
                    {OPERATOR_TO_TEXT[operator]}
                  </Option>
                )
              )}
            </Section>
          )}
        </Menu>
      }
    >
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        fullWidth={true}
        isDropdown={true}
        size={props.buttonSize}
        text={OPERATOR_TO_TEXT[props.selectedOperator]}
        dataTestAttrs={{component: 'OperatorDropdown', element: 'button'}}
      />
    </Dropdown>
  );
}
export default OperatorDropdown;

const styles = StyleSheet.create({
  operatorSectionHeader: {
    textTransform: 'none',
    fontWeight: 'normal',
  },
});
